import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: '',
    isAdmin: false,
    cards: [],
    galleryPhotos: [],
    attachedFiles: [],
    selection: [],
    selectionShowClosed: false,
    selectionSelect: {},
    peopleFilter: {}
  },
  mutations: {
    login (state, user) {
      state.user = user
    },
    isAdmin (state, data) {
      state.isAdmin = data
    },
    cards (state, data) {
      state.cards = data
    },
    galleryPhotos (state, data) {
      state.galleryPhotos = data
    },
    attachedFiles (state, data) {
      state.attachedFiles = data
    },
    selection (state, data) {
      state.selection = data
    },
    selectionShowClosed (state, data) {
      state.selectionShowClosed = data
    },
    selectionSelect (state, data) {
      state.selectionSelect = data
    },
    peopleFilter (state, data) {
      state.peopleFilter = data
    }
  },
  getters: {
    user: state => state.user,
    isAdmin: state => state.isAdmin,
    cards: state => state.cards,
    galleryPhotos: state => state.galleryPhotos,
    attachedFiles: state => state.attachedFiles,
    selection: state => state.selection,
    selectionShowClosed: state => state.selectionShowClosed,
    selectionSelect: state => state.selectionSelect,
    peopleFilter: state => state.peopleFilter
  },
  actions: {
    login ({ commit }, user) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/v1/login', user)
          .then(response => {
            commit('login', response.data.user)
            this.dispatch('checkAdmin')
            resolve()
          })
          .catch(err => {
            console.log('Action login(), Error')
            // commit('logout');
            reject(err)
          })
      })
    },
    checkLogin () {
      console.log('kontrolujem session')
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/login')
          .then(response => {
            if (response.data.user === null) {
              console.log('nema session')
              reject(response.data.user)
            } else {
              this.commit('login', response.data.user)
              this.dispatch('checkAdmin')
              resolve('sessionOK')
            }
          })
          .catch(err => {
            console.log('error: get session confirm')
            reject(err)
          })
      })
    },
    logout () {
      return new Promise((resolve, reject) => {
        const action = 'logout'
        axios
          .post('/api/v1/login', { action })
          .then(response => {
            console.log(response.data.message)
            this.state.user = ''
            resolve()
          })
          .catch(err => {
            console.log('Action logout(), Error')
            reject(err)
          })
      })
    },
    checkAdmin () {
      axios.get('/api/v1/admin/user').then(response => {
        var user = this.state.user
        var results: any = response.data.filter(function (allUsers: any) {
          return allUsers.email === user
        })
        this.state.isAdmin = results[0].admin
      })
    }
  }
})
